import Marquee from "react-fast-marquee";
import { MEATS } from "@/lib/menuData";

export const MeatsMarquee = () => {
  const items = [...MEATS, ...MEATS];
  return (
    <div
      data-testid="meats-marquee"
      className="bg-[color:var(--brand-red)] text-white border-y-2 border-[color:var(--brand-ink)] overflow-hidden"
    >
      <Marquee speed={60} gradient={false} pauseOnHover>
        <div className="flex items-center py-4 font-display text-3xl sm:text-4xl uppercase tracking-wide">
          {items.map((m, i) => (
            <span key={i} className="mx-8 flex items-center gap-8">
              {m}
              <span className="inline-block w-3 h-3 bg-[color:var(--brand-yellow)] rotate-45" />
            </span>
          ))}
        </div>
      </Marquee>
    </div>
  );
};

export default MeatsMarquee;
